module.exports = __webpack_public_path__ + "img/banner3.beb81854.jpg";